import { Routes } from "@angular/router";
import { WorkflowPartnerAiTariffOrderCancelComponent } from "./workflow-partner-ai-tariff-order-cancel.component";


export const WorkflowPartnerAiTariffOrderCancelRouting: Routes = [
    {
        path: 'partner/change-ai-tariff/:aid/order-cancel', component: WorkflowPartnerAiTariffOrderCancelComponent
    },
]